<div class="integration-preview">
    <a [routerLink]="['.', 'id', integration.id]">{{integration.label || integration.id}}</a>
</div>
